import { Home, Users,Table,Smartphone,PieChart,FilePlus,Monitor,Map,FileText, List, Clock, Layers,  MapPin, Settings, AlertTriangle, DollarSign } from 'react-feather';

export const MENUITEMS = [
   /* {
        menutitle: 'General',
        menucontent: 'Tickets,Paiements,Co',
        Items: [
            {
                title: 'Dashboard', icon: Home, type: 'sub', active: true, children: [
                    { path: `${process.env.PUBLIC_URL}/dashboard/default`, title: 'Tickets', icon: Home, type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`, title: 'Paiements', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`, title: 'Contestations', type: 'link' },
                ]
            }
        ]
    },*/
    {
        menutitle: 'Dashboard_Sidebar_General',
        menucontent: 'Informations',
        Items: [
            {
                title: 'Dashboard_Sidebar_Home', icon: Map, type: 'link', active: false, path: `${process.env.PUBLIC_URL}/dashboard/home`
            },
            {
                title: "Dashboard_Sidebar_Avis", icon: FileText, type: 'link', active: false, path: `${process.env.PUBLIC_URL}/dashboard/avis`
            },
            {
                title: "Dashboard_Sidebar_VehicleAlerts", icon: AlertTriangle, type: 'link', active: false, path: `${process.env.PUBLIC_URL}/dashboard/alertes-vehicules`
            },
            {
                title: "Dashboard_Sidebar_Contracts", icon: Layers, type: 'link', active: false, path: `${process.env.PUBLIC_URL}/dashboard/contracts`
            },

        ]
    },

    {
        menutitle: 'Dashboard_Sidebar_Users',
        menucontent: '',
        Items: [
            {
                title: 'Dashboard_Sidebar_Profiles', icon: Users, type: 'link', active: false, path: `${process.env.PUBLIC_URL}/dashboard/users`
            },

            {
                title: 'Dashboard_Sidebar_Timesheets', icon: Clock, type: 'link', active: false, path: `${process.env.PUBLIC_URL}/dashboard/users/activite-terrain`
            }
        ]
    },

    {
        menutitle: 'Dashboard_Sidebar_Reports',
        menucontent: 'Tickets,Paiements,Co',
        Items: [

            {
                title: 'Dashboard_Sidebar_Data', icon: PieChart, type: 'sub', active: false, children: [
                    { path: `${process.env.PUBLIC_URL}/dashboard/reports/avis`, title: 'Dashboard_Sidebar_Avis', icon: Home, type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/dashboard/reports/users`, title: 'Dashboard_Sidebar_Agents', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/dashboard/reports/contrats`, title: 'Dashboard_Sidebar_Contracts', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/dashboard/reports/heatmap`, title: 'Dashboard_Sidebar_HeatMap', type: 'link' },   
                    { path: `${process.env.PUBLIC_URL}/dashboard/reports/history`, title: 'Dashboard_Sidebar_History', type: 'link' },   
                    { path: `${process.env.PUBLIC_URL}/admin/reports`, title: 'Dashboard_Sidebar_DailyHealth', type: 'link' },   
                    { path: `${process.env.PUBLIC_URL}/dashboard/reports/expenses`, title: 'Dashboard_Sidebar_Expenses', icon: DollarSign, type: 'link' },
                ]
            }
    
        ]
    },

    {
        menutitle: 'Dashboard_Sidebar_MobileApp',
            menucontent: '',
            Items: [

                {
                    title: 'Dashboard_Sidebar_Configuration', icon: Smartphone, type: 'link', active: false, path: `${process.env.PUBLIC_URL}/dashboard/mobile`
                }
            ]
        }
]
